
































































































import Vue from 'vue'
import '../codemirror-global.js'
import CodeMirror, { EditorConfiguration } from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/edit/closebrackets.js'
import { Video } from '@/models/Video'
import VideoInfoViewer from '@/components/VideoInfoViewer.vue'
import VideoSliderBar from '@/components/VideoSliderBar.vue'
import LoadingViwer from '@/components/LoadingViewer.vue'
import 'vue-slider-component/theme/default.css'
import { CodingPlayer } from '@/CodingPlayer'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPlay,
  faPause,
  faUndo,
  faStepForward,
  faFastForward,
} from '@fortawesome/free-solid-svg-icons'
import { formatRecordingTime } from '@/util'

library.add(faPlay, faPause, faUndo, faStepForward, faFastForward)

type DataType = {
  editor?: CodeMirror.EditorFromTextArea
  backgroundEditor?: CodeMirror.EditorFromTextArea
  defualtConfig: EditorConfiguration
  player: CodingPlayer
  speedSliderIndex: number[]
  isSpeedMenuOpen: boolean
}

function readTextFile(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    var fr = new FileReader()
    fr.onload = () => {
      resolve(fr.result)
    }
    fr.onerror = reject
    fr.readAsText(file)
  })
}

export default Vue.extend({
  name: 'PlayerPage',
  components: {
    VideoInfoViewer,
    VideoSliderBar,
    FontAwesomeIcon,
    LoadingViwer,
  },
  data(): DataType {
    const snapShotTimeSpan = 30000
    return {
      defualtConfig: {
        mode: 'javascript',
        lineNumbers: true,
        indentUnit: 4,
        theme: 'monokai',
        showHint: true,
        readOnly: true,
      },
      player: new CodingPlayer(snapShotTimeSpan, this.$store.getters.speed),
      speedSliderIndex: [50, 100, 200],
      isSpeedMenuOpen: false,
    }
  },
  computed: {
    speed: {
      get: function (): number {
        return this.player.info.speed
      },
      set: function (value: number) {
        this.$store.dispatch('setSpeedAction', value)
        this.player.setSpeed(value)
      },
    },
    playbackPosition: function (): string {
      // prettier-ignore
      return `${formatRecordingTime(this.player.info.elapsedTime)} / ${formatRecordingTime(this.player.info.totalTime)}`
    },
  },
  methods: {
    setEditorSize: function () {
      const sidePanelWidth = 300
      const bottomPanelHeight = 200
      let width = document.body.clientWidth - sidePanelWidth
      let height = document.body.clientHeight - bottomPanelHeight
      width = width >= 0 ? width : 0
      height = height >= 0 ? height : 0
      console.log('resize w :' + width + 'h:' + height)
      this.editor?.setSize(width, height)
    },
    toggleSpeedMenu: function (): void {
      this.isSpeedMenuOpen = !this.isSpeedMenuOpen
    },
    loadData: async function (event: Event): Promise<void> {
      this.player.pause()
      this.player.clear(this.editor)
      const target = event.target as HTMLInputElement
      const file = target.files?.item(0)
      if (file == null) {
        // ファイルがなければ何もしない
        return
      }
      const videoJson = (await readTextFile(file)) as string
      const video: Video = JSON.parse(videoJson)
      this.player.load(video, this.editor, this.backgroundEditor)
    },
    start: function (): void {
      this.player.start(this.editor)
    },
    pouse: function (): void {
      this.player.pause()
    },
    backToTheBeginning: function (): void {
      this.player.backToTheBeginning(this.editor)
    },
    stepForward: function (): void {
      this.player.stepForward(this.editor)
    },
    fastForward: function (): void {
      this.player.fastForward(this.editor)
    },
    move: function (time: number): void {
      this.player.move(time, this.editor)
    },
    observerUrlDo: async function (): Promise<void> {
      this.speed = this.$store.getters.speed
      this.player.pause()
      this.player.clear(this.editor)
      if (this.$route.query.src == null) {
        return
      }
      try {
        const response = await fetch(
          process.env.BASE_URL + '/video/' + this.$route.query.src.toString()
        )
        if (response.ok) {
          const video = (await response.json()) as Video
          this.player.load(video, this.editor, this.backgroundEditor)
          return
        } else {
          // それ以外の場合はエラーを表示
          const message =
            `message:${await response.text()}\n` +
            `http status:${response.status} ${response.statusText}`
          alert(message)
          return
        }
      } catch (error: unknown) {
        // 通信エラーの場合はアラートで表示
        alert((error as Error).message)
        return
      }
    },
  },
  watch: {
    async $route(): Promise<void> {
      // 2回目呼び出し
      await this.observerUrlDo()
    },
  },
  async mounted(): Promise<void> {
    // 裏で動かす用のエディタ
    const backgroundEditorArea: HTMLTextAreaElement | null =
      document.querySelector('#background-editor-aria')
    if (backgroundEditorArea == null) {
      throw new Error('textarea not found for Background CodeMirror')
    }
    this.backgroundEditor = CodeMirror.fromTextArea(backgroundEditorArea)
    this.backgroundEditor.setSize('0px', '0px')
    // 画面を再生する用のエディタ
    const editorAria: HTMLTextAreaElement | null =
      document.querySelector('#editor-aria')
    if (editorAria == null) {
      throw new Error('textarea not found for CodeMirror')
    }
    const config = this.defualtConfig
    this.editor = CodeMirror.fromTextArea(editorAria, config)
    this.setEditorSize()
    window.onresize = this.setEditorSize
    await this.observerUrlDo()
  },
  beforeDestroy(): void {
    window.onresize = null
  },
})
